import React from 'react';
import { FilterableSelect } from '../../../../../../components/ui/FilterableSelect';
import { formatTaxId } from '../../../../../../features/deliveries/orderUploadUtils';
import { DOCUMENT_LABEL_BY_COUNTRY } from '../../../../../../features/deliveries/orderUploadConstants';
import { PLAN_OPTIONS } from '../../../../../../features/sellers/sellerFormConstants';
import { Field, inputClass } from '../components/FormField';

/**
 * Who the seller is: the company that will be billed and the plan it operates
 * under.
 *
 * There is no owner field. The seller is always attached to the admin of the
 * current session, so there is nothing to choose.
 *
 * @param {object} props
 * @param {object} props.form
 * @param {Object.<string, string>} props.errors
 * @param {(name: string, value: string) => void} props.onChange
 * @param {string} props.country - ISO2 of the account, driving the tax id mask
 */
export const CompanyStep = ({ form, errors, onChange, country }) => {
  const documentLabel = DOCUMENT_LABEL_BY_COUNTRY[country] || 'RUT';

  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <Field label="Razón Social" error={errors.razonSocial}>
          <input
            value={form.razonSocial}
            onChange={(event) => onChange('razonSocial', event.target.value)}
            maxLength={100}
            placeholder="Ej: Comercializadora Andes SpA"
            className={inputClass}
          />
        </Field>

        <Field label={documentLabel} error={errors.taxId}>
          <input
            value={form.taxId}
            onChange={(event) => onChange('taxId', formatTaxId(event.target.value, country))}
            placeholder={documentLabel === 'RFC' ? 'Ej: ABC010203XYZ' : 'Ej: 76.123.456-7'}
            className={inputClass}
          />
        </Field>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <FilterableSelect
            variant="form"
            label="Tipo de Plan"
            value={form.plan}
            onChange={(value) => onChange('plan', value)}
            options={PLAN_OPTIONS}
            hasError={Boolean(errors.plan)}
            searchPlaceholder="Buscar plan..."
          />
          {errors.plan && <p className="text-danger text-xs mt-1">{errors.plan}</p>}
        </div>
      </div>
    </div>
  );
};
